import { useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

import { loginAdmin } from "../../../services/apis";
import { useFormik } from "formik";
import * as Yup from "yup";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { IconButton, InputAdornment, FormHelperText } from "@mui/material";
import { useDispatch } from "react-redux";
import { setAdminData } from "../../../redux/slices/adminDataSlice";

function SignIn() {
  const dispatch=useDispatch()
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };
 
  // ✅ Validation Schema using Yup
  const validationSchema = Yup.object({
    email: Yup.string()
      .test("email", "Enter a valid Email", (value) => {
        if (!value) return false;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
  });

  // ✅ Formik Hook
  const formik = useFormik({
    initialValues: { email: "", password: "" },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response= await loginAdmin(values);
        if(response?.success){
          // console.log('response: ', response.data);
          const { jwtAccessToken, jwtRefreshToken }= response?.data 
          localStorage.setItem("token", jwtAccessToken)
          localStorage.setItem("refresh_token", jwtRefreshToken)
          dispatch(setAdminData(response.data));
          navigate("/");
        }
        }
       catch (error) {
        formik.setErrors({ email: error?.message || "Error Occured" });
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="light"
          borderRadius="lg"
          coloredShadow="light"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
            WEDDZ
          </MDTypography>
          <MDTypography variant="h5" fontWeight="medium" color="white" mt={1}>
            Login
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                id="email"
                error={formik.touched.email && Boolean(formik.errors.email)}
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email && (
                <FormHelperText error>{formik.errors.email}</FormHelperText>
              )}
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                  type={showPassword ? "text" : "password"}
                label="Password"
                fullWidth
                id="password"
                error={formik.touched.password && Boolean(formik.errors.password)}
                {...formik.getFieldProps("password")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={handleTogglePassword} edge="end">
                        {showPassword ? <Visibility />: <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              {formik.touched.password && formik.errors.password && (
                <FormHelperText error>{formik.errors.password}</FormHelperText>
              )}
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="light" fullWidth
                disabled={loading || !formik.isValid || !formik.dirty}>
                  <MDTypography color="white" fontWeight="medium" style={{fontSize:"18px"}} >

                  Login
                  </MDTypography>
              </MDButton>
            </MDBox>
     
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default SignIn;
